import Geocode from 'react-geocode';

const key = process.env.REACT_APP_MAPS_KEY;

export const locationByIP = async () => {
  const getCoords = async () => {
    const pos = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
    return {
      lng: pos.coords.longitude,
      lat: pos.coords.latitude,
    };
  };
  return getCoords();
};

export const locationByAddress = async (address) => {
  // Primeiro, tentar usar Google Maps se a chave estiver configurada
  if (key && key !== 'undefined' && key.trim() !== '') {
    try {
      Geocode.setApiKey(key);
      Geocode.setLanguage('pt');
      Geocode.setRegion('br');
      Geocode.enableDebug();

      const response = await Geocode.fromAddress(address);
      const { lat, lng } = response.results[0].geometry.location;
      return {
        lat,
        lng,
      };
    } catch (error) {
      console.error('GEOCODE (Google Maps): ', error);
      // Se falhar, tentar Nominatim
    }
  }

  // Usar Nominatim (OpenStreetMap) como fallback - gratuito e sem chave
  try {
    console.log('🔍 Usando Nominatim (OpenStreetMap) para geocodificar:', address);
    
    // Função auxiliar para fazer requisição ao Nominatim
    const buscarNominatim = async (enderecoFormatado) => {
      const encodedAddress = encodeURIComponent(enderecoFormatado);
      
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?q=${encodedAddress}&format=json&limit=1&addressdetails=1&countrycodes=br`,
        {
          headers: {
            'User-Agent': 'ManifestoOnline/1.0', // Nominatim requer User-Agent
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    };
    
    // Tentar diferentes formatos de endereço
    const formatosEndereco = [];
    
    // 1. Endereço original (limpo)
    formatosEndereco.push(address.trim());
    
    // 2. Remover vírgulas extras e espaços duplos
    formatosEndereco.push(address.replace(/,\s*,/g, ',').replace(/\s+/g, ' ').trim());
    
    // 3. Formato simplificado: logradouro, número, bairro, cidade, estado
    const partes = address.split(',').map(p => p.trim()).filter(p => p);
    if (partes.length > 0) {
      // Tentar com menos partes (remover CEP e "Brasil")
      const partesSemCep = partes.filter(p => !p.match(/^\d{8}$/) && p !== 'Brasil');
      if (partesSemCep.length > 0) {
        formatosEndereco.push(partesSemCep.join(', '));
      }
      
      // Tentar apenas cidade, estado
      if (partes.length >= 2) {
        const cidadeEstado = partes.slice(-2).join(', ');
        formatosEndereco.push(cidadeEstado);
      }
      
      // Tentar logradouro + número + cidade + estado
      if (partes.length >= 4) {
        const logradouroNumero = partes[0];
        const cidadeEstado = partes.slice(-2).join(', ');
        formatosEndereco.push(`${logradouroNumero}, ${cidadeEstado}`);
      }
    }
    
    // Remover duplicatas
    const formatosUnicos = [...new Set(formatosEndereco)];
    
    // Tentar cada formato até encontrar um resultado
    for (const formato of formatosUnicos) {
      try {
        console.log(`🔍 Tentando formato: ${formato}`);
        const data = await buscarNominatim(formato);
        
        if (data && data.length > 0) {
          const result = data[0];
          const lat = parseFloat(result.lat);
          const lng = parseFloat(result.lon);
          
          console.log('✅ Coordenadas obtidas via Nominatim:', { lat, lng, formato });
          
          return {
            lat,
            lng,
          };
        }
      } catch (error) {
        console.warn(`⚠️ Erro ao tentar formato "${formato}":`, error);
        continue;
      }
      
      // Pequeno delay entre requisições para respeitar rate limit do Nominatim
      await new Promise(resolve => setTimeout(resolve, 500));
    }
    
    console.warn('⚠️ Nenhum resultado encontrado no Nominatim após tentar todos os formatos para:', address);
    return {
      lat: 0,
      lng: 0,
    };
  } catch (error) {
    console.error('❌ Erro ao geocodificar com Nominatim:', error);
    return {
      lat: 0,
      lng: 0,
    };
  }
};

export default locationByAddress;
